<!--
 * @Author: nzj
 * 审核确认
-->
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('审核详情')"
      custom-class="j-dialog"
      :close-on-click-modal="false"
      top="45px"
      :visible.sync="viewDialogVisible"
      @close="close"
      width="960px">
      <div class="dialog-center">
        <div class="title">{{ $lang('申请信息') }}</div>
        <div class="content1_top">
          <div class="dialog-step1-list">
            <p class="dialog-step1-t1">{{$lang('单号')}}：</p>
            <p class="dialog-step1-t2">{{ rowData.waybillNo || '--' }}</p>
          </div>
          <div class="dialog-step1-list">
            <p class="dialog-step1-t1">{{$lang('申请类型')}}：</p>
            <p class="dialog-step1-t2">{{ rowData.applyTypeName || '--' }}</p>
          </div>
        </div>
        <div class="title">{{ $lang('退件原因') }}</div>
        <div class="content1">
          {{ rowData.rebackTransferReason || '--' }}
        </div>
        <div class="title">{{ $lang('原单收寄件人信息') }}</div>
        <div class="content1">
          <div class="send">
            <div class="content-icon">
              <div class="send-text">{{ $lang('寄') }}</div>
            </div>
            <div class="content-info">
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件姓名')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号1')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderMobilePhone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号2')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderTelphone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件省份')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderProvinceName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件城市')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderCityName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件区县')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderAreaName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件街道')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.senderStreet || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件楼号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.sendBuildingNo || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件楼层')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.sendFloor || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件房号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.sendRoomNumber || '--' }}</p>
              </div>
            </div>
          </div>
          <div class="receive">
            <div class="content-icon icon-color">
              <div class="send-text">{{ $lang('收') }}</div>
            </div>
            <div class="content-info">
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件姓名')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号1')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverMobilePhone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号2')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverTelphone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件省份')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverProvinceName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件城市')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverCityName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件区县')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverAreaName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件街道')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverStreet || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件楼号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverBuildingNo || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件楼层')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverFloor || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件房号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.receiverRoomNumber || '--' }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="title">{{ $lang('新单收寄件人信息') }}</div>
        <div class="content1">
          <div class="send">
            <div class="content-icon">{{ $lang('寄') }}</div>
            <div class="content-info">
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件姓名')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号1')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderMobilePhone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号2')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderTelphone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件省份')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderProvinceName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件城市')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderCityName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件区县')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderAreaName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件街道')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSenderStreet || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件楼号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSendBuildingNo || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件楼层')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSendFloor || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('寄件房号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newSendRoomNumber || '--' }}</p>
              </div>
            </div>
          </div>
          <div class="receive">
            <div class="content-icon icon-color">{{ $lang('收') }}</div>
            <div class="content-info">
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件姓名')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号1')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverMobilePhone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('手机号2')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverTelphone || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件省份')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverProvinceName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件城市')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverCityName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件区县')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverAreaName || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件街道')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverStreet || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件楼号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverBuildingNo || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件楼层')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverFloor || '--' }}</p>
              </div>
              <div class="dialog-step1-list">
                <p class="dialog-step1-t1">{{$lang('收件房号')}}：</p>
                <p class="dialog-step1-t2">{{ rowData.newReceiverRoomNumber || '--' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ReturnApplicationDetail',
  props: {
    viewDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: _ => {
        return {}
      },
    },
  },
  data() {
    return {
    }
  },
  watch: {
    rowData(newV) {

    }
  },
  methods: {
    close() {
      this.$emit('update:viewDialogVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-center {
  height: 600px;
  overflow: auto;

  .title {
    background: #f2f2f2;
    padding: 10px;
    font-size: 14px;
    font-weight: 700;
  }
  .content1_top {
    display: flex;
    padding: 10px;

    .dialog-step1-list {
      width: 200px;
    }
  }
  .content1 {
    display: flex;
    flex-direction: column;
    padding: 10px;

    .send, .receive {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
    }

    .content-icon {
      width: 40px;
      height: 40px;
      color: rgba(255, 153, 0, 0.87);
      border: 1px solid rgba(255, 153, 0, 0.87);
      border-radius: 50%;
      margin-right: 30px;

      .send-text {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        font-size: 16px;
      }
    }

    .icon-color {
      color: red;
      border-color: red;
    }

    .content-info {
      display: flex;
      flex-wrap: wrap;
    }

    .dialog-step1-list {
      width: 200px;
      height: 36px;
      margin-bottom: 10px;

      .dialog-step1-t1{
        width:200px;
        height:14px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:14px;
        margin: 0;
        margin-bottom: 8px;
      }
      .dialog-step1-t2{
        width:200px;
        height:14px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:14px;
        margin: 0;
      }
    }
  }
}
</style>
